import { DynamicJobFilter } from '@borg/types';

class JobFiltersRepository extends Repository<DynamicJobFilter> {
  getMany() {
    return this._getMany({ url: `/jobs/search/filters`, cache: 'always' });
  }
}

export const jobFiltersRepository = new JobFiltersRepository();
